import React from "react";
import { Typography } from "antd";

import { Button } from "../../../../../components";
import "./style.css";

const { Title } = Typography;


const ForumFollowBox = ({image, title, count, type, onClick, buttonText}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 grid-rows-1 mt-10 mb-5">
      <div className="content text-left">
        <img src={image} />
        <div>
          <Title level={5}>{title}</Title>
          <p>{`${count} Members`} </p>
          <p>{`${type} Forum`}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Button
          type="primary"
          className="mt-5 lg:mt-10 button-quad w-full md:w-1/2"
          title={buttonText}
          onClick={onClick}
          style={{ height: "35px", borderRadius: "30px" }}
        />
      </div>
    </div>
  );
};

export default ForumFollowBox;
